import { useState } from 'react';
import Zoom from '@mui/material/Zoom';

import CustomizedTooltip from 'components/common/CustomizedTooltip/CustomizedTooltip';

import * as S from './TextWithTooltip.styled';

type Props = {
    text: string;
};

const TextWithTooltip = ({ text }: Props) => {
    const [openMilNameTooltip, setOpenMilNameTooltip] = useState<boolean>(false);

    const handleTooltipClose = () => {
        setTimeout(() => {
            setOpenMilNameTooltip(false);
        }, 270);
    };

    const handleTooltipOpen = () => {
        setTimeout(() => {
            setOpenMilNameTooltip(true);
        }, 260);
    };

    return (
        <CustomizedTooltip
            sx={{
                '&.MuiTooltip-popper[data-popper-placement*="bottom"] .MuiTooltip-tooltip': {
                    marginTop: '8px',
                },
            }}
            disableTouchListener
            onClose={handleTooltipClose}
            open={openMilNameTooltip}
            title={text}
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 240 }}
            placement="bottom-start"
        >
            <S.Text
                onClick={handleTooltipOpen}
                onMouseEnter={handleTooltipOpen}
                onMouseLeave={handleTooltipClose}
            >
                {text}
            </S.Text>
        </CustomizedTooltip>
    );
};

export default TextWithTooltip;
